export function NotFound() {
  return <h2>Page Not Found</h2>;
}
